module.exports = __webpack_public_path__ + "img/b82cac3.svg";